












































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import OrderApi, { ExchangeOrderRequest } from "@/services/api/order";
import { AxiosError, AxiosResponse } from "axios";
import ErrorService, { ValidationErrors } from "@/services/errors";
import Order from "@/models/order";
import {
    mdiAlert,
    mdiCallMade,
    mdiCallReceived,
    mdiPlus,
    mdiSwapHorizontal,
} from "@mdi/js";
import InternalLink from "@/components/InternalLink.vue";
import { Action, Getter } from "vuex-class";
import { User } from "@/models/user";
import UserApi from "@/services/api/user";
import firebase, {
    addAnalyticsEvent,
    ensureAuthenticated,
} from "@/plugins/firebase";
import { captureSentryException, captureSentryMessage } from "@/plugins/sentry";
import StatusCodes from "http-status-codes";
import CompositeAlert from "@/components/CompositeAlert.vue";
import PhoneNumberApi from "@/services/api/phone-number";
import PhoneNetwork from "@/models/phone-network";
import UserProfile from "@/models/user-profile";
import SettingsApi from "@/services/api/settings";
import Settings from "@/models/settings";
import { isWebView } from "@/plugins/utils";

export interface NetworkSelectItem {
    text: string;
    icon: string;
    value: string | number | boolean;
}

@Component({
    components: {
        CompositeAlert,
        InternalLink,
        Link: InternalLink,
    },
})
export default class ExchangeIndex extends Vue {
    formEmail: string = "";
    formPaymentMethod: string = "mtn-mobile-money";
    formPhoneNumber: string = "";
    exchangeIcon: string = mdiSwapHorizontal;
    formInputErrors: ValidationErrors = new ValidationErrors();
    isSubmitting: boolean = false;
    isValidatingPhoneNumber = false;
    formAmount = 500;
    formRecipientPhoneNumber: string = "";
    alertIcon: string = mdiAlert;
    plusIcon: string = mdiPlus;
    receiveIcon: string = mdiCallReceived;
    payIcon: string = mdiCallMade;
    formPhoneNetwork: string = "orange-cameroon";
    settings: Settings | null = null;

    @Getter("user") user!: User | null;
    @Getter("userIsAnonymous") userIsAnonymous!: boolean;
    @Getter("authToken") authToken!: string;
    @Getter("userIsAdmin") userIsAdmin!: boolean;
    @Getter("referralCode") referralCode!: string;
    @Action("setUser") setUser!: (user: User | null) => void;
    @Action("setAuthToken") setAuthToken!: (authToken: string | null) => void;

    get networks(): Array<NetworkSelectItem> {
        return [
            {
                value: "mtn-cameroon",
                icon: "https://s3.amazonaws.com/rld-operator/b589ad8d-f6c0-482e-a596-4360ba55b23d-size-1.png",
                text: "MTN Mobile Money",
            },
            {
                value: "orange-cameroon",
                icon: "https://s3.amazonaws.com/rld-operator/fb214865-e85f-47cd-918f-ab69b7953e82-size-1.png",
                text: "Orange Money",
            },
        ];
    }

    get isWebView(): boolean {
        return isWebView();
    }

    get phoneNetwork(): NetworkSelectItem | null {
        const network = this.networks.find(
            (x) => x.value === this.formPhoneNetwork
        );
        return network ?? null;
    }

    get transactionFeesPercentage(): number {
        let depositFees = 0;
        if (this.formPhoneNetwork == "mtn-cameroon") {
            depositFees = this.settings?.exchange.mtnDepositFees ?? depositFees;
        } else {
            depositFees =
                this.settings?.exchange.orangeDepositFees ?? depositFees;
        }

        let withdrawalFees = 0;
        if (this.formPaymentMethod == "mtn-mobile-money") {
            withdrawalFees =
                this.settings?.exchange.mtnWithdrawalFees ?? withdrawalFees;
        } else {
            withdrawalFees =
                this.settings?.exchange.orangeWithdrawalFees ?? withdrawalFees;
        }
        return depositFees + withdrawalFees;
    }

    get transactionFees(): number {
        return Math.ceil(this.formAmount * this.transactionFeesPercentage);
    }

    get amountPlusFees(): number {
        return (
            parseFloat(this.formAmount.toString()) +
            parseFloat(this.transactionFees.toString())
        );
    }

    get phoneNetworkName(): string {
        return this.phoneNetwork?.text ?? "";
    }

    get phoneNetworkLogo(): string {
        return this.phoneNetwork?.icon ?? "";
    }

    get hasPhoneNetwork(): boolean {
        return (
            this.phoneNetwork !== null &&
            this.formRecipientPhoneNumber.trim().length > 0
        );
    }

    get formPhoneNumberPlaceholder(): string {
        if (!this.formPaymentMethod) {
            return "Phone number e.g 6xxxxxxxx";
        }
        return `${this.paymentMethodString} number e.g 6xxxxxxxx`;
    }

    get paymentMethodString(): string {
        if (this.formPaymentMethod === "mtn-mobile-money") {
            return "MTN Mobile Money";
        }
        return "Orange Money";
    }

    get canCalculateFees(): boolean {
        return (
            this.phoneNetwork !== null &&
            !!this.formAmount &&
            !!this.formPaymentMethod
        );
    }

    onPayment() {
        addAnalyticsEvent("exchange_pay_clicked", { amount: this.formAmount });
        this.isSubmitting = true;

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const handleError = (error: any) => {
            this.isSubmitting = false;
            this.handleError(error);
        };

        this.$recaptcha("exchange_mobile_money")
            .then((token: string) => {
                const payload: ExchangeOrderRequest = {
                    captcha: token,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    payment_method: this.formPaymentMethod,
                    email: this.formEmail,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    phone_number: this.formPhoneNumber,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    phone_network: this.formPhoneNetwork,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    recipient_phone_number: this.formRecipientPhoneNumber,
                    amount: parseInt(this.formAmount.toString()),
                };
                this.ensureUserExists()
                    .then(() => {
                        this.createOrder(payload);
                    })
                    .catch(handleError);
            })
            .catch(handleError);
    }

    setProfileFromAuthUser() {
        this.formEmail = this.user?.email || "";
    }

    validatePhoneNumber() {
        this.isValidatingPhoneNumber = true;
        this.$recaptcha("validate_smartcard")
            .then((token: string) => {
                PhoneNumberApi.store(this.formRecipientPhoneNumber, token)
                    .then((response: AxiosResponse) => {
                        this.formInputErrors.clear("recipient_phone_number");
                        const phoneNetwork = new PhoneNetwork(
                            response.data.data
                        );
                        this.formPhoneNetwork = phoneNetwork.id;
                    })
                    .catch(this.handleAxiosError)
                    .finally(() => {
                        this.isValidatingPhoneNumber = false;
                    });
            })
            .catch((error) => {
                this.isValidatingPhoneNumber = false;
                this.handleError(error);
            });
    }

    loadProfile() {
        if (!firebase.auth().currentUser?.uid) {
            captureSentryException(
                "cannot load profile for an unauthenticated user"
            );
            return;
        }

        UserApi.getProfile(firebase.auth().currentUser?.uid as string)
            .then((response: AxiosResponse) => {
                const userProfile = new UserProfile(response.data.data);
                this.formPhoneNumber = userProfile.paymentPhoneNumber ?? "";
                this.formEmail = userProfile.email ?? this.user?.email ?? "";
                if (this.formRecipientPhoneNumber.length !== 9) {
                    this.formRecipientPhoneNumber =
                        userProfile.exchange?.recipientPhoneNumber ?? "";
                    this.formPhoneNetwork =
                        userProfile.exchange?.phoneNetwork ??
                        this.formPhoneNetwork;
                }
            })
            .catch((error: AxiosError) => {
                if (error.response?.status === StatusCodes.NOT_FOUND) {
                    this.setProfileFromAuthUser();
                    return;
                }
                this.handleAxiosError(error);
            });
    }

    mounted() {
        if (typeof this.$route.query.p === "string") {
            this.formRecipientPhoneNumber = this.$route.query.p.trim();
        }
        this.loadSettings();
        if (this.user || this.userIsAnonymous) {
            ensureAuthenticated()
                .then(() => {
                    this.loadProfile();
                })
                .catch(this.handleError);
        }
    }

    loadSettings(): Promise<void> {
        return SettingsApi.get()
            .then((response: AxiosResponse) => {
                this.settings = new Settings(response.data.data);
            })
            .catch(this.handleAxiosError);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleError(error: any) {
        if (error instanceof Error && error.message) {
            captureSentryException(error);
            this.$root.$emit(
                this.$constants.NOTIFICATION_EVENTS.ERROR,
                error.message
            );
            return;
        }

        captureSentryMessage(error);
        this.$root.$emit(
            this.$constants.NOTIFICATION_EVENTS.ERROR,
            "We could not carry out your request. It may be because your internet connection is not so good. Please try again"
        );
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ensureUserExists(): Promise<any> {
        if (this.authToken) {
            return new Promise<boolean>((resolve) => resolve(true));
        }
        return firebase
            .auth()
            .signInAnonymously()
            .then(async (response) => {
                this.setUser(response.user);
                this.setAuthToken((await response.user?.getIdToken()) || null);
                addAnalyticsEvent("anonymous_user_created_before_order");
            });
    }

    createOrder(payload: ExchangeOrderRequest) {
        OrderApi.createExchange(payload)
            .then((response: AxiosResponse) => {
                const order = new Order(response.data.data);
                this.$root.$emit(
                    this.$constants.NOTIFICATION_EVENTS.SUCCESS,
                    "Your order has been created successfully"
                );

                addAnalyticsEvent("begin_checkout", {
                    currency: "XAF",
                    value: order.paymentAmount,
                    items: [
                        {
                            // eslint-disable-next-line @typescript-eslint/camelcase
                            item_id: order.itemId,
                            // eslint-disable-next-line @typescript-eslint/camelcase
                            item_name: order.itemName,
                            affiliation: this.phoneNetworkName,
                            currency: "XAF",
                        },
                    ],
                });

                this.$router.push({
                    name: this.$constants.ROUTE_NAMES.ORDERS_SHOW,
                    params: {
                        orderId: order.orderId,
                    },
                });
            })
            .catch(this.handleAxiosError)
            .finally(() => {
                this.isSubmitting = false;
            });
    }

    handleAxiosError(error: AxiosError) {
        this.formInputErrors = ErrorService.getValidationErrors(error);
        this.handleError(
            new Error(error?.response?.data?.message ?? error.message)
        );
    }
}
